
<div mat-dialog-title>
    {{patient.nameSurname + ' '}}  <span class="ml-3" [class]="patient.sex =='M' ? 'icon-male' : patient.sex =='F'? 'icon-female': 'icon-neutral'" ></span>
    
    <div class="spacer"></div>
    <button mat-raised-button color="primary" class="mb-2" [disabled]="selection.selected.length == 0" (click)="viewReports()">
      Ver informes
    </button>
    <!--button mat-mini-fab color="warn" class="close-button" mat-dialog-close>
      <mat-icon class="close-icon">close</mat-icon>
    </button-->
  </div>
  
  <div class="mb-3">
    <span *ngIf="patient.birthdate" class="bold">Edad: </span> <span [matTooltip]="patient.birthdate" class="mr-3">{{patient.age}}</span>
    <span *ngIf="patient.fiscalCode" class="bold">DNI: </span> <span class="mr-3">{{patient.fiscalCode}}</span>
    <span *ngIf="patient.healthCode" class="bold">{{env.hc_label}}: </span> <span class="mr-3">{{patient.healthCode}}</span>    
    
  </div>

  <div mat-dialog-content> 
  <table class="table table-sm">
    <thead>
    <tr>
      <th>
        <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()"
          style="position: relative; top: 3px;">
        </mat-checkbox>
      </th>
      <th class="align-middle" scope="col">Fecha</th>
      <th class="align-middle" scope="col"></th>
      <th class="align-middle" scope="col"></th>
      <th class="align-middle" scope="col">Protocolo</th>
      <th class="align-middle" scope="col">Servicio</th>
      <th scope="col"></th>
    </tr>
    </thead>
    <tbody>

    <tr *ngFor="let order of orders" (click)="selectOrder(order)">
      <td class="align-middle">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(order):null"
          [checked]="selection.isSelected(order)" [aria-label]="checkboxLabel(order)"
          style="position: relative; top: 3px;" [disabled]="order.orderState < 5">
        </mat-checkbox>
      </td>
      <td class="align-middle">{{ order.orderDate }}</td>
      <td class="align-middle"> <mat-icon *ngIf="order.doctorNameSurname != null" class="doctor-icon ml-3" svgIcon="doctor"
        [matTooltip]="order.doctorNameSurname"></mat-icon></td>
      <td class="align-middle">
        <mat-icon *ngIf="order.ysnCriticalAlarm == -1" aria-hidden="false" class="alert-icon"
            aria-label="alert icon" matTooltip="Resultados fuera de los valores de referencia">error_outline
          </mat-icon>
      </td>
      <td class="align-middle">
        <span class="order-badge" [class.urgent-badge]  = "order.priorityLevel == 3" >
          {{ order.orderId }}
        </span> 
      </td>
      <td class="align-middle">{{ order.ward.wardDescription }}</td>
      <td class="align-middle">
        <button mat-icon-button *ngIf="group.gridResult"  (click)="viewResults(order); $event.stopPropagation()">
          <mat-icon aria-hidden="false" aria-label="view results icon">view_list</mat-icon>
        </button> 
        <button mat-icon-button (click)="viewReport(order); $event.stopPropagation()"
          [color]="order.reportState >= 2 ? env.color_report_complete:env.color_report_partial" [disabled]="order.reportState == 0"
          [matTooltip]="order.reportState >= 2 ? 'Informe final':'Informe parcial'">
          <mat-icon
          aria-hidden="false" aria-label="print icon">description</mat-icon>
        </button>        
      </td>
      

    </tr>
    </tbody>
  </table>
  
  </div>

  <mat-dialog-actions align="center" >
      <button mat-raised-button mat-dialog-close color="warn">Cerrar</button>
    
  <!--button mat-raised-button [mat-dialog-close]="" (click) color="primary">Si</button-->

</mat-dialog-actions>
